import { useCallback } from "react";

import { updatePlannerTokenSharing } from "../../../../services/apiSystemSettings";
import { localStorageInstance } from "../../../../utils/localStorage";
import { shouldResetPlannerTokens } from "../utils/systemSettingUtils";
import { useSimpleSettingsForm } from "./useSimpleSettingsForm";

export function usePlannerSettingsForm(initialData) {
  const form = useSimpleSettingsForm({
    initialData: {
      planner_token_sharing_enabled:
        initialData?.planner_token_sharing_enabled ?? false,
    },
    mutationFn: updatePlannerTokenSharing,
    invalidateKeys: ["tenant-details", "planner-token-sharing"],
  });

  const onSubmit = useCallback(
    (formData) => {
      if (shouldResetPlannerTokens(formData.planner_token_sharing_enabled)) {
        localStorageInstance.removeItem("planner_user_id");
        localStorageInstance.removeItem("planner_refresh_token");
        localStorageInstance.removeItem("planner_access_token");

        if (window?.__REACT_QUERY_CLIENT__) {
          window.__REACT_QUERY_CLIENT__.removeQueries(["todos"]);
        } else if (typeof window !== "undefined" && window.queryClient) {
          window.queryClient.removeQueries(["todos"]);
        }
      }

      form.onSubmit({
        planner_token_sharing_enabled: formData.planner_token_sharing_enabled,
      });
    },
    [form]
  );

  return {
    ...form,
    onSubmit,
  };
}
